import { isOn } from '@/lib/growthbook';

export const GENERAL_SCHEDULE_RULES_FLAG = 'populate-general-schedule-from-availabilities';

export function useGeneralScheduleRules(): boolean {
  return isOn(GENERAL_SCHEDULE_RULES_FLAG);
}
